// import { Icon } from "@sjofartsdir/component-library";
import * as React from "react";
import { useIntl } from "react-intl";
import styled, { ThemeContext } from "styled-components";
import { SdiArrow } from "@sdir/sds";
import { useContext } from "react";

const Header: React.FC = ({ children }) => {
  const intl = useIntl();
  const theme = useContext(ThemeContext)
  return (
    <>
      <Head>
        <NavigationBar>
          <span>
            <BackButton href={"https://www.sdir.no/"}>
              <CustomSdiArrow direction={"left"} size={"s"} color={theme.colors.background.secondary} />
              {intl.formatMessage({ id: "back.button" })}
            </BackButton>
          </span>
        </NavigationBar>
      </Head>
      <div>{children}</div>
    </>
  );
};

export default Header;

const CustomSdiArrow = styled(SdiArrow)`
  height: 8px !important;
  margin-bottom: 0.1em;
`;

const Head = styled.header`
  color: ${({ theme }) => theme.colors.background.secondary};
  display: flex;
  justify-content: space-between;
  align-items: center;
  top: 0;
  left: 0;
  background: ${({ theme }) => theme.colors.primary};
  border-bottom: 1px solid ${({ theme }) => theme.colors.background.secondary};
  box-shadow: 0 0 10px -5px #ccc;
  height: 90px;
  width: 100%;
`;

const NavigationBar = styled.div`
  margin: auto;
  width: 100%;
  max-width: 1140px;
  @media only screen and (max-width: ${({ theme }) => theme.screen.desktop}) {
    max-width: 960px;
  }
  @media only screen and (max-width: ${({ theme }) => theme.screen.tablet}) {
    max-width: 720px;
  }
  @media only screen and (max-width: ${({ theme }) => theme.screen.phone}) {
    max-width: 540px;
  }
`;

const BackButton = styled.a`
  vertical-align: middle;
  line-height: 60px;
  text-align: center;
  margin-left: 25px;
  font-size: 18px;
  font-weight: 600;
  padding-top: 0.3125rem;
  padding-bottom: 0.3125rem;
  text-decoration: none;
  color: ${({ theme }) => theme.colors.background.secondary};
  svg {
    height: 6px;
    margin-bottom: 0.2em;
    margin-right: 0.35em;
  }
`;
